import React, { ChangeEvent } from "react";
import { Form } from "react-bootstrap";
import ControlFeedback from "./../../../components/Fields/ControlFeedback";
import LayoutControlOption from "./LayoutControlOption";
import { RadioButtonListControlProps } from "./../../../components/Fields/Types";
import image_1x1 from "./../../../assets/img/layouts/1x1_image.jpg"
import image_1x3 from "./../../../assets/img/layouts/1x3_image.jpg"
import image_3x1 from "./../../../assets/img/layouts/3x1_image.jpg"
import image_3x2 from "./../../../assets/img/layouts/3x2_image.jpg"

const RadioButtonListControl: React.FC<RadioButtonListControlProps> = ({ name, value, disabled, width, validationResults, onChange, onBlur }) => {

    let isValid = validationResults && validationResults.length > 0 ? false : true;

    if (width === undefined)
        width = '100%';

    const options = [
        { value: 1, label: '3x2', image:image_3x2 },
        { value: 2, label: '1x1', image: image_1x1 },
        { value: 3, label: '1x3', image: image_1x3 },
        { value: 4, label: '3x1', image: image_3x1 },
        { value: 5, label: '3x1 wide', image: image_3x1 },
    ]

    if (!options)
        return <></>;

    var radios = options.map((option, index: number) => {
        return <LayoutControlOption name={name} value={value} disabled={disabled} onChange={onChange} onBlur={onBlur} validationResults={validationResults} option={option} />
    })

    return (
        <div style={{ width: width }}>
            {radios}
            <ControlFeedback isValid={isValid} validationResults={validationResults}></ControlFeedback>
        </div>
    );
}
export default RadioButtonListControl;